import { z } from 'zod';
import { PLAN } from '../constants/index.ts';

// Create restaurant schema
export const createRestaurantSchema = z.object({
  slug: z
    .string()
    .min(3)
    .max(50)
    .regex(
      /^[a-z0-9-]+$/,
      'Slug must contain only lowercase letters, numbers, and hyphens'
    ),
  name: z.string().min(1).max(100),
  telegramBotToken: z.string().min(1),
  telegramBotUsername: z
    .string()
    .min(1)
    .regex(/^[a-zA-Z][a-zA-Z0-9_]{4,}$/, 'Invalid Telegram bot username'),
  ordersChannelId: z.string().min(1),
});

// Update restaurant schema
export const updateRestaurantSchema = z.object({
  name: z.string().min(1).max(100).optional(),
  active: z.boolean().optional(),
  plan: z.enum([PLAN.FREE, PLAN.BASIC, PLAN.PRO]).optional(),
  ordersChannelId: z.string().min(1).optional(),
  pickupEnabled: z.boolean().optional(),
  deliveryEnabled: z.boolean().optional(),
});

// Telegram init data validation
export const telegramInitDataSchema = z.object({
  query_id: z.string().optional(),
  user: z
    .object({
      id: z.number(),
      first_name: z.string(),
      last_name: z.string().optional(),
      username: z.string().optional(),
      language_code: z.string().optional(),
    })
    .optional(),
  auth_date: z.number(),
  hash: z.string(),
});

// Types inferred from schemas
export type CreateRestaurantInput = z.infer<typeof createRestaurantSchema>;
export type UpdateRestaurantInput = z.infer<typeof updateRestaurantSchema>;
// Note: TelegramInitData is already defined in types/telegram.ts

